import { render, staticRenderFns } from "./user-config.vue?vue&type=template&id=6c6b1964&scoped=true&"
import script from "./user-config.vue?vue&type=script&lang=ts&"
export * from "./user-config.vue?vue&type=script&lang=ts&"
import style0 from "./user-config.vue?vue&type=style&index=0&id=6c6b1964&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6b1964",
  null
  
)

export default component.exports